var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGrayTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_968_5210",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_968_5210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1334 18.4001L11.2667 15.5334C11.0223 15.289 10.7112 15.1667 10.3334 15.1667C9.95564 15.1667 9.64453 15.289 9.40008 15.5334C9.15564 15.7779 9.03341 16.089 9.03341 16.4667C9.03341 16.8445 9.15564 17.1556 9.40008 17.4001L13.2001 21.2001C13.4667 21.4667 13.7779 21.6001 14.1334 21.6001C14.489 21.6001 14.8001 21.4667 15.0667 21.2001L22.6001 13.6667C22.8445 13.4223 22.9667 13.1112 22.9667 12.7334C22.9667 12.3556 22.8445 12.0445 22.6001 11.8001C22.3556 11.5556 22.0445 11.4334 21.6667 11.4334C21.289 11.4334 20.9779 11.5556 20.7334 11.8001L14.1334 18.4001ZM16.0001 29.3334C14.1556 29.3334 12.4223 28.9834 10.8001 28.2834C9.17786 27.5834 7.76675 26.6334 6.56675 25.4334C5.36675 24.2334 4.41675 22.8223 3.71675 21.2001C3.01675 19.5779 2.66675 17.8445 2.66675 16.0001C2.66675 14.1556 3.01675 12.4223 3.71675 10.8001C4.41675 9.17786 5.36675 7.76675 6.56675 6.56675C7.76675 5.36675 9.17786 4.41675 10.8001 3.71675C12.4223 3.01675 14.1556 2.66675 16.0001 2.66675C17.8445 2.66675 19.5779 3.01675 21.2001 3.71675C22.8223 4.41675 24.2334 5.36675 25.4334 6.56675C26.6334 7.76675 27.5834 9.17786 28.2834 10.8001C28.9834 12.4223 29.3334 14.1556 29.3334 16.0001C29.3334 17.8445 28.9834 19.5779 28.2834 21.2001C27.5834 22.8223 26.6334 24.2334 25.4334 25.4334C24.2334 26.6334 22.8223 27.5834 21.2001 28.2834C19.5779 28.9834 17.8445 29.3334 16.0001 29.3334Z",
    fill: "#DEDEDE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGrayTick);
export default __webpack_public_path__ + "static/media/ic_gray_tick.817f8071f4f0f8828dd0c89073b091b3.svg";
export { ForwardRef as ReactComponent };